import { http } from 'vue'

export default {
  postUser (context, params = {}) {
    return http.post('users', params)
  },
  loadUser (context, params = {}) {
    let headers = {}
    if (params.accessToken) {
      headers.Authorization = 'Bearer ' + params.accessToken
    }
    return http.get('user', {headers: headers})
  },
  changeUser (context, payload) {
    context.commit('CHANGE_USER', JSON.parse(JSON.stringify(payload)))
  },
  unsetUser (context) {
    context.commit('UNSET_USER')
  },
  // save client at the store
  saveAddress (context, payload) {
    context.commit('SAVE_ADDRESS', payload)
  },
  // save client at the store
  saveReferences (context, payload) {
    context.commit('SAVE_REFERENCES', payload)
  },
  // load status from the API server
  loadStatus (context) {
    return http.get('status')
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js